export default __webpack_public_path__ + "static/media/shopping-cart.ec57a4c7.png";